import { matchPath } from "react-router-dom";

export const useRouteMatchSsr = (testedUrl: string) => {
    //@ts-ignore
    const serverLocation = window.serverLocation            //serverLocation заполняется на сервере в мидлваре
    const isMatchPath = matchPath(serverLocation.pathname, {
        path: testedUrl,
        exact: true,
    })
    
    return !!isMatchPath
}


export const useParamsSsr = (testedUrl?: any) => {
    //@ts-ignore
    const serverLocation = window.serverLocation            //serverLocation заполняется на сервере в мидлваре
    const isMatchPath = matchPath(serverLocation.pathname, {
        path: testedUrl,
        exact: true,
    })
    return isMatchPath?.params as any
}import { matchPath } from "react-router-dom";

export const useRouteMatchSsr = (testedUrl: string) => {
    //@ts-ignore
    const serverLocation = window.serverLocation            //serverLocation заполняется на сервере в мидлваре
    const isMatchPath = matchPath(serverLocation.pathname, {
        path: testedUrl,
        exact: true,
    })
    
    return !!isMatchPath
}


export const useParamsSsr = (testedUrl?: any) => {
    //@ts-ignore
    const serverLocation = window.serverLocation            //serverLocation заполняется на сервере в мидлваре
    const isMatchPath = matchPath(serverLocation.pathname, {
        path: testedUrl,
        exact: true,
    })
    return isMatchPath?.params as any
}